import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = { class: "w-100 text-right" }

import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriterionEditorViewModel } from "@Criteria/Hierarchies/Components/CriterionEditor"

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriterionEditor',
  props: {
        viewModel: {
            type: Object as PropType<CriterionEditorViewModel>,
            required: true
        }
    },
  emits: ["delete-criterion", "update-criterion"],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const criterionId = computed(() => vm.value.criterionId)
    const isGoal = computed(() => vm.value.isGoal)
    const nameError = computed(() => vm.value.nameError)

    // ---------------- actions ----------------

    function emitDeleteCriterion()
    {
        emit("delete-criterion", criterionId.value!)
    }

    function emitUpdateCriterion()
    {
        vm.value.clearValidationErrors()
        emit("update-criterion", criterionId.value!, vm.value.name, vm.value.description)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Edit criterion", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  id: "criterion-editor-form",
                  onSubmit: _withModifiers(emitUpdateCriterion, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", null, [
                      _createTextVNode("Name "),
                      _createElementVNode("span", { style: {"color":"red"} }, "*")
                    ], -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.name) = $event)),
                      type: "text",
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        vm.value.name,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(nameError.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.value.description) = $event)),
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        vm.value.description,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (!isGoal.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-danger float-left",
                        onClick: emitDeleteCriterion
                      }, "Delete"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: close,
                    class: "btn btn-outline-secondary"
                  }, "Cancel"),
                  _cache[5] || (_cache[5] = _createElementVNode("button", {
                    type: "submit",
                    form: "criterion-editor-form",
                    class: "btn btn-primary"
                  }, "Update", -1 /* CACHED */))
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})